"use client";

import { ModalHeader as HeroModalHeader } from "@heroui/react";
import { cn } from "../../lib/utils";

export const ModalHeader = ({
  className,
  ...props
}: { className?: string } & React.ComponentProps<typeof HeroModalHeader>) => {
  return <HeroModalHeader className={cn(className)} {...props} />;
};
